// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router from './router'
import VueFire from 'vuefire';
import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false;
Vue.use(VueFire);
Vue.use(BootstrapVue);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js